module.exports = __webpack_public_path__ + "img/guangao05.da3e6cf8.png";